export const AdType = {
  Rewarded: 'rewarded',
  Interstitial: 'interstitial',
  Display: 'display',
};

// Google's Ad Placement API placement types, used verbatim as the SDK's `position`
// so config, logs and the ad request all say the same word. 'reward' is missing on
// purpose: a rewarded ad is reached through AdType.Rewarded, and letting it in here
// would send type:'reward' without the reward callbacks.
export const InterstitialPlacements = ['preroll', 'start', 'pause', 'next', 'browse'];

// A break requested mid-game is the common case; 'preroll' is passed explicitly by
// the one caller that owns the splash.
export const DefaultInterstitialPlacement = 'next';
